export function useFooter() {
  const { t } = useI18n()

  const aboutLinks = computed(() => [
    { text: t('key.footer.about.us'), url: 'https://corporate.azgotrip.com/about-us' },
    { text: t('key.footer.products'), url: 'https://corporate.azgotrip.com/products' },
    { text: t('key.footer.press'), url: 'https://corporate.azgotrip.com/press-media-coverage' },
    { text: t('key.footer.about.us.sitemap'), url: 'https://www.azgo.ai/ttd/html-sitemap' },
  ])

  const partnershipsLinks = computed(() => [
    { text: t('key.footer.solutions'), url: 'https://corporate.azgotrip.com/solutions' },
    { text: t('key.footer.become.partner'), url: 'https://corporate.azgotrip.com/partnership-enquiry' },
    { text: t('key.footer.become.distributor'), url: 'https://corporate.azgotrip.com/affiliate-program' },
  ])

  return {
    aboutLinks,
    partnershipsLinks,
  }
}
